module.exports = __webpack_public_path__ + "static/no_data_img.156934f4.png";